import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStats = ({ assets }) => {
  const calculateStats = () => {
    const total = assets?.length;
    const active = assets?.filter(a => a?.status === 'active')?.length;
    const spare = assets?.filter(a => a?.status === 'spare')?.length;
    const repair = assets?.filter(a => a?.status === 'repair')?.length;
    const retired = assets?.filter(a => a?.status === 'retired')?.length;
    
    // Calculate warranty expiring soon (within 30 days)
    const thirtyDaysFromNow = new Date();
    thirtyDaysFromNow?.setDate(thirtyDaysFromNow?.getDate() + 30);
    const warrantyExpiring = assets?.filter(asset => {
      const warrantyDate = new Date(asset.warrantyExpiration);
      return warrantyDate <= thirtyDaysFromNow && warrantyDate >= new Date();
    })?.length;

    return {
      total,
      active,
      spare,
      repair,
      retired,
      warrantyExpiring
    };
  };

  const stats = calculateStats();

  const statCards = [
    {
      title: 'Total Assets',
      value: stats?.total,
      icon: 'Package',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: '+12 this month'
    },
    {
      title: 'Active Assets',
      value: stats?.active,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: `${Math.round((stats?.active / stats?.total) * 100)}% of total`
    },
    {
      title: 'Need Attention',
      value: stats?.repair,
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      change: stats?.repair > 0 ? 'Requires action' : 'All good'
    },
    {
      title: 'Warranty Expiring',
      value: stats?.warrantyExpiring,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      change: 'Next 30 days'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg border border-border p-6 shadow-subtle hover:shadow-moderate transition-smooth"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                {stat?.title}
              </p>
              <p className="text-2xl font-bold text-card-foreground mt-2">
                {stat?.value?.toLocaleString()}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {stat?.change}
              </p>
            </div>
            <div className={`p-3 rounded-lg ${stat?.bgColor}`}>
              <Icon 
                name={stat?.icon} 
                size={24} 
                className={stat?.color}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;